import styles from './CallTranscript.module.scss';

export const CallTranscript = ({ messages }) => (
    <div className={styles.transcriptSection}>
        <h3>Call Transcript</h3>
        <div className={styles.transcriptMessages}>
            {messages.map((msg, i) => (
                <div
                    key={i}
                    className={`${styles.msgRow} ${msg.sender === 'SLAI Agent' ? styles.agent : styles.client}`}
                >
                    <p className={styles.sender}>{msg.sender}</p>
                    <div className={styles.msgBubble}>{msg.text}</div>
                </div>
            ))}
        </div>
    </div>
);
